export default __webpack_public_path__ + "static/media/crypto_dark.1f18e909.png";